import {WSCommonActions} from "@pledger/frontend-commons";
import {enrollmentTokenWServiceActions} from "./enrollmentToken/enrollmentTokenWServiceActions";
import {enrollmentWServiceActions} from "./enrollment/enrollmentWServiceActions";
import {loginWServiceActions} from "./login/loginWServiceActions";
import {accountWServiceActions} from "./account/accountWServiceActions";
import {souscriptionCGPWServiceActions} from "./SouscriptionCGP/souscriptionCGPWServiceActions";
import {souscriptionSelfcareWServiceActions} from "./SouscriptionSelfcare/souscriptionSelfcareWServiceActions";
import {loanRequestStatusesWServiceActions} from "./LoanRequestStatuses/loanRequestStatusesWServiceActions";
import {contactWServiceActions} from "./contact/contactWServiceActions";
import {resetPasswordWServiceActions} from "./resetPassword/resetPasswordWServiceActions";
import {renewPasswordWServiceActions} from "./renewPassword/renewPasswordWServiceActions";
import {changePasswordWServiceActions} from "./changePassword/changePasswordWServiceActions";
import {changeEmailWServiceActions} from "./changeEmail/changeEmailWServiceActions";
import {changePhoneNumberWServiceActions} from "./changePhoneNumber/changePhoneNumberWServiceActions";
import {souscriptionSuiviWServiceActions} from "./SouscriptionSuivi/souscriptionSuiviWServiceActions";
import {webAuthnWServiceActions} from "./webAuthn/webAuthnWServiceActions";

export const WServiceActions = {
    ...WSCommonActions,
    ...enrollmentTokenWServiceActions,
    ...enrollmentWServiceActions,
    ...loginWServiceActions,
    ...accountWServiceActions,
    ...souscriptionSelfcareWServiceActions,
    ...souscriptionCGPWServiceActions,
    ...loanRequestStatusesWServiceActions,
    ...contactWServiceActions,
    ...resetPasswordWServiceActions,
    ...renewPasswordWServiceActions,
    ...changePasswordWServiceActions,
    ...changeEmailWServiceActions,
    ...changePhoneNumberWServiceActions,
    ...souscriptionSuiviWServiceActions,
    ...webAuthnWServiceActions
};






